import { isPublishedAppVersionNewer } from '@/shared/lib/appVersionCompare'
import { fetchRemoteAppVersion } from '@/shared/pwa/remoteAppVersion'
import { clearStaleChunkReloadAttempt } from '@/shared/pwa/staleDeploymentRecovery'
import { showPwaUpdateToast } from '@/shared/pwa/showPwaUpdateToast'

/**
 * Compara `version.json` na origem com `__APP_VERSION__` do bundle; se houver versão mais
 * nova publicada, mostra toast persistente com «Atualizar» (sem reload automático).
 */
export async function checkForPwaUpdateAndToast(): Promise<void> {
  if (import.meta.env.DEV) return

  const remote = await fetchRemoteAppVersion()
  if (!remote) return

  const running = __APP_VERSION__
  if (!isPublishedAppVersionNewer(remote.version, running)) {
    clearStaleChunkReloadAttempt()
    return
  }

  showPwaUpdateToast()
}
